import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api/api'
import { getToken,removeToken,setToken } from "./assets/js/auth";
import { destroyActiveGuide, getGuideIdForRoute } from "./utils/featureGuide";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/feature-guide.css';

import "@/assets/css/public.css"
import "@/assets/css/mobile-shell.css"
import "@/assets/css/iconfont.css"

Vue.config.productionTip = false
Vue.prototype.$axios = api
Vue.prototype.getToken = getToken;
Vue.prototype.removeToken = removeToken;
Vue.prototype.setToken = setToken;
Vue.prototype.$destroyFeatureGuide = destroyActiveGuide;
Vue.prototype.$startFeatureGuide = function (manual) {
  var route = this.$route;
  var guideId = getGuideIdForRoute(route && route.path);
  if (guideId) {
    this.$root.$emit("ebk-start-feature-guide", { manual: manual !== false, guideId: guideId });
    return;
  }
  this.$root.$emit("ebk-start-feature-guide", { manual: manual !== false, guideId: "app_nav" });
};
Vue.use(ElementUI);


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js